import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { TargetGroupFilter } from '../../target-group-filters/target-group-filter.interface';
import { TargetGroupFilterService } from './target-group-filter.service';

const service = new TargetGroupFilterService();

export interface TargetGroupFilterState {}

const TargetGroupFilterStore: Module<TargetGroupFilterState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getTargetGroupFilters(context, teamId: number) {
         const response = await service.getTargetGroupFilters(teamId);
         return response;
      },
      async postTargetGroupFilters(context, payload: { teamId: number; targetGroupFilters: Array<TargetGroupFilter> }) {
         const { teamId, targetGroupFilters } = payload;
         const response = await service.postTargetGroupFilters(teamId, targetGroupFilters);
         return response;
      },
      async deleteTargetGroupFilter(context, teamId: number) {
         const response = await service.deleteTargetGroupFilter(teamId);
         return response;
      },
   },
};

export default TargetGroupFilterStore;
